define.alias("shared/utils/upgrade/choose-your-upgrade", "settings/utils/upgrade/choose-your-upgrade");